"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCreateOrderOptions = void 0;
exports.defaultCreateOrderOptions = {
    clientBalanceSat: 0,
    lspNodeId: undefined,
    couponCode: '',
    turboChannel: false,
    zeroReserve: false,
    zeroConfPayment: undefined,
    wakeToOpen: undefined,
};
//# sourceMappingURL=ICreateOrderOptions.js.map